import { render } from "./PantryDetailView.vue?vue&type=template&id=2f38cc50&ts=true"
import script from "./PantryDetailView.vue?vue&type=script&lang=ts"
export * from "./PantryDetailView.vue?vue&type=script&lang=ts"

import "./PantryDetailView.vue?vue&type=style&index=0&id=2f38cc50&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__